(function ($) {

    let $carousel, $initialObject;
    $(document).ready(function () {
        $carousel = $('#home-testimonials');
        $initialObject = $carousel.clone();
        initCarousel();
    });

    $(window).on('resize', initCarousel);

    function initCarousel() {
        if (!$carousel.hasClass('carousel') && $(window).width() < 768) {
            $carousel.addClass('carousel').addClass('slide');

            $('#home-testimonials > div').addClass('carousel-inner');
            $('#home-testimonials > div > div').addClass('carousel-item');
            $('#home-testimonials > div > div:first-child').addClass('active');

            $carousel.carousel({
                ride: true,
                interval: 4 * 1000
            });
        } else if ($(window).width() > 768) {
            $carousel
                .removeClass('carousel')
                .html($initialObject.html());
        }
    }

})(jQuery);
